import React, {useEffect, useState} from 'react';
import client from '../../../../client';

export const Reviews = () => {
    const query = "*[_type == 'review' ] { _id, name, company, comment }";

    const [reviews, setReviews] = useState([
        {
            name: "",
            company: "",
            comment: ""
        },
        {
            name: "",
            company: "",
            comment: ""
        }
    ]);


    useEffect(()=>{
        client.fetch(query, {}).then((result) => {
            let array = result;
            for (let i = array.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                const temp = array[i];
                array[i] = array[j];
                array[j] = temp;
            }
            setReviews(array)
        })
    }, [])




    return (
        <>
            <div className={"review"}>
                <h3 className={"review__name putDot"}>{reviews[0].name}</h3>
                <p  className={"review__company"}>{reviews[0].company}</p>
                <p className={"review__comment"}>{reviews[0].comment}</p>
            </div>
            <div className={"review"}>
                <h3  className={"review__name putDot"}>{reviews[1].name}</h3>
                <p className={"review__company"}>{reviews[1].company}</p>
                <p className={"review__comment"}>{reviews[1].comment}</p>
            </div>
        </>
    );
};

export default Reviews;
